import { useTranslation } from 'react-i18next';

import { Button, ButtonVariant } from '@/components/form/button';

interface IProps {
  title: string;

  thumbnailImage: string;

  onClick?: () => void;

  buttonColor: string;
}

export const LoginMethodCard: React.FC<IProps> = ({
  onClick,
  title,
  thumbnailImage,
  buttonColor,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex bg-gray rounded-[40px] z-20">
      <div>
        <img src={thumbnailImage} alt="login category selection" />
      </div>
      <div className="flex flex-col justify-between py-4 grow">
        <span className="w-2/3 text-lg font-bold place-self-start">{t(title)}</span>
        <Button
          classnames={`${buttonColor} place-self-end font-bold mr-10 z-10`}
          variant={ButtonVariant.Link}
          onClick={onClick}
        >
          Go to <span className="ml-2 font-light">&gt;</span>
        </Button>
      </div>
    </div>
  );
};
